import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'

export const Route = createFileRoute('/(private)/bando/$residenceId/offerte')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-offers:page_title'
				)
			}
		]
	}),
	staticData: {
		breadcrumb: 'admin-offers:page_title'
	},
	component: () => <Outlet />
})
